var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { key: _vm.refreshImport },
        _vm._l(_vm.currentStep.fields, function (field, indexField) {
          return _vm.showWithDependency(field, _vm.currentStep.fields)
            ? _c(
                "b-col",
                {
                  key: indexField,
                  staticClass: "form-group",
                  attrs: { cols: field.type === "file" ? "12" : "6" },
                },
                [
                  field.type === "date"
                    ? _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t(
                            "suppliers.kyc_form." +
                              _vm.currentStep.step_label +
                              "." +
                              field.label
                          ),
                          inputType: "date",
                        },
                        model: {
                          value: field.value,
                          callback: function ($$v) {
                            _vm.$set(field, "value", $$v)
                          },
                          expression: "field.value",
                        },
                      })
                    : field.type === "text"
                    ? _c("div", [
                        _c("label", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "suppliers.kyc_form." +
                                    _vm.currentStep.step_label +
                                    "." +
                                    field.label
                                )
                              ) +
                              "\n          "
                          ),
                          field.required && field.required === "true"
                            ? _c("span", { staticClass: "color-red" }, [
                                _vm._v("* "),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        field.label === "LegalForm"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "form-write-group-label-input",
                                  {
                                    class: _vm.hasError(field)
                                      ? "errorBorder"
                                      : "",
                                    attrs: { inputType: "listeSelect" },
                                    on: {
                                      change: function ($event) {
                                        _vm.refreshImport = !_vm.refreshImport
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: field.value,
                                            expression: "field.value",
                                          },
                                        ],
                                        staticClass:
                                          "form-control inputAccordionForm",
                                        attrs: { id: "sel2", readonly: "" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              field,
                                              "value",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "suppliers.slct_legal_status"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.legalStatusList["FR"],
                                          function (status) {
                                            return _c(
                                              "option",
                                              {
                                                key: status.code,
                                                domProps: {
                                                  value: status.label,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(status.label) +
                                                    "\n            "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : field.label === "NAFCode"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "form-write-group-label-input",
                                  {
                                    class: _vm.hasError(field)
                                      ? "errorBorder"
                                      : "",
                                    attrs: { inputType: "listeSelect" },
                                    on: {
                                      change: function ($event) {
                                        _vm.refreshImport = !_vm.refreshImport
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: field.value,
                                            expression: "field.value",
                                          },
                                        ],
                                        staticClass:
                                          "form-control inputAccordionForm",
                                        attrs: { id: "sel2", readonly: "" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              field,
                                              "value",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "suppliers.slct_naf_status"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.nafStatusList["FR"],
                                          function (status) {
                                            return _c(
                                              "option",
                                              {
                                                key: status.code,
                                                domProps: {
                                                  value:
                                                    status.code +
                                                    " - " +
                                                    status.label,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(status.label) +
                                                    "\n            "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : field.label === "CreationDate" ||
                            field.label === "DeliveryDate" ||
                            field.label === "BirthDate"
                          ? _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: field.value,
                                    expression: "field.value",
                                  },
                                ],
                                staticClass: "form-control inputAccordionForm",
                                attrs: { type: "date" },
                                domProps: { value: field.value },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      field,
                                      "value",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ])
                          : _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: field.value,
                                    expression: "field.value",
                                  },
                                ],
                                staticClass: "form-control inputAccordionForm",
                                class: _vm.hasError(field) ? "errorBorder" : "",
                                attrs: { type: "text" },
                                domProps: { value: field.value },
                                on: {
                                  change: function ($event) {
                                    _vm.refreshImport = !_vm.refreshImport
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      field,
                                      "value",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                        _vm._v(" "),
                        !_vm.demoErrorSilent.includes(field.errorDesc)
                          ? _c("div", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(field.errorDesc) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : field.type === "checkbox"
                    ? _c(
                        "div",
                        { staticClass: "d-flex flex-row mt-4" },
                        [
                          _c("b-form-checkbox", {
                            attrs: {
                              value: "true",
                              "unchecked-value": "false",
                            },
                            on: {
                              change: function ($event) {
                                _vm.refreshImport = !_vm.refreshImport
                              },
                            },
                            model: {
                              value: field.value,
                              callback: function ($$v) {
                                _vm.$set(field, "value", $$v)
                              },
                              expression: "field.value",
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "suppliers.kyc_form." +
                                      _vm.currentStep.step_label +
                                      "." +
                                      field.label
                                  )
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      )
                    : field.type === "radio"
                    ? _c(
                        "div",
                        [
                          _c("label", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "suppliers.kyc_form." +
                                      _vm.currentStep.step_label +
                                      "." +
                                      field.label +
                                      "._label"
                                  )
                                ) +
                                "\n          "
                            ),
                            field.required && field.required === "true"
                              ? _c("span", { staticClass: "color-red" }, [
                                  _vm._v("* "),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm._l(field.possible_values, function (radioValue) {
                            return _c(
                              "b-form-radio",
                              {
                                key: radioValue,
                                attrs: {
                                  value: radioValue,
                                  name: field.label + "-radio",
                                },
                                model: {
                                  value: field.value,
                                  callback: function ($$v) {
                                    _vm.$set(field, "value", $$v)
                                  },
                                  expression: "field.value",
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "suppliers.kyc_form." +
                                          _vm.currentStep.step_label +
                                          "." +
                                          field.label +
                                          "." +
                                          radioValue
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : field.type === "list"
                    ? _c(
                        "form-write-group-label-input",
                        {
                          attrs: {
                            isMandatory:
                              field.required && field.required === "true",
                            inputLabel: _vm.$t(
                              "suppliers.kyc_form." +
                                _vm.currentStep.step_label +
                                "." +
                                field.label +
                                "._label"
                            ),
                            inputType: field.type,
                          },
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: field.value,
                                  expression: "field.value",
                                },
                              ],
                              staticClass: "form-control",
                              class: _vm.hasError(field) ? "errorBorder" : "",
                              attrs: { readonly: "" },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      field,
                                      "value",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function ($event) {
                                    return _vm.checkInvalidValue(field)
                                  },
                                ],
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }),
                              _vm._v(" "),
                              _vm._l(
                                field.possible_values,
                                function (optionValue) {
                                  return _c(
                                    "option",
                                    { domProps: { value: optionValue } },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t(
                                              "suppliers.kyc_form." +
                                                _vm.currentStep.step_label +
                                                "." +
                                                field.label +
                                                "." +
                                                optionValue
                                            )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          !_vm.demoErrorSilent.includes(field.errorDesc)
                            ? _c("div", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(field.errorDesc) +
                                    "\n        "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : field.type === "file"
                    ? _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              _c("label", { staticClass: "pb-2" }, [
                                _c("h6", { staticClass: "font-weight-bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "suppliers.kyc_form." +
                                          _vm.currentStep.step_label +
                                          "." +
                                          field.label
                                      )
                                    )
                                  ),
                                  field.required && field.required === "true"
                                    ? _c("span", { staticClass: "color-red" }, [
                                        _vm._v(" *"),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]),
                              _vm._v(" "),
                              field.value === "true"
                                ? _c(
                                    "div",
                                    [
                                      _vm.step.documentData
                                        ? _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "form-group",
                                                  attrs: { sm: "12" },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-between align-items-center align-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "text-label-doc",
                                                          staticStyle: {
                                                            "margin-bottom":
                                                              "0",
                                                            "margin-right":
                                                              "20px",
                                                          },
                                                          attrs: {
                                                            id: "application-file-input",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa-light fa-minus",
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.step
                                                                  .documentName
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-link-purple",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.download(
                                                                _vm.step
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.dwnld"
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-link-danger",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.clearDocument(
                                                                field
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.rm_label"
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-col", {
                                                staticClass: "form-group",
                                                attrs: { cols: "4" },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm.step.documentId &&
                                          _vm.step.status !== 101
                                        ? _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "form-group",
                                                  attrs: { sm: "12" },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-between align-items-center align-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "text-label-doc",
                                                          staticStyle: {
                                                            "margin-bottom":
                                                              "0",
                                                            "margin-right":
                                                              "20px",
                                                          },
                                                          attrs: {
                                                            id: "application-file-input",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa-light fa-minus",
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.step
                                                                  .documentName
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-link-purple",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.download(
                                                                _vm.step
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.dwnld"
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-col", {
                                                staticClass: "form-group",
                                                attrs: { cols: "4" },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-row",
                                    { staticClass: "justify-content-start" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { cols: "5" },
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openFileSelectionWindow(
                                                    $event,
                                                    "fileButton" + field.label
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "attachments.import_doc"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            ref: "fileButton" + field.label,
                                            refInFor: true,
                                            staticClass:
                                              "item-input hiddenElementAllSize local-file-input",
                                            attrs: { type: "file" },
                                            on: {
                                              change: function ($event) {
                                                return _vm.executeOCR(
                                                  $event,
                                                  field,
                                                  _vm.currentStep
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      field.doc_type === "KBIS"
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: { cols: "6" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.callInstitutionalSource(
                                                        $event,
                                                        field,
                                                        _vm.currentStep
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "suppliers.ask_institut_KBIS"
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      field.doc_type === "STATUS"
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: { cols: "6" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.callInstitutionalSource(
                                                        $event,
                                                        field,
                                                        _vm.currentStep
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "suppliers.ask_institut_STATUS"
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e()
        }),
        1
      ),
      _vm._v(" "),
      _vm.showActionButtons()
        ? _c(
            "b-row",
            { staticClass: "justify-content-start" },
            [
              _vm.showActionButtonValidate()
                ? [
                    _c(
                      "b-col",
                      {
                        staticClass: "form-group",
                        attrs: { md: "2", "offset-md": "8" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.decideStep(102)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-save" }),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("common.sve")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { md: "2" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              size: "lg",
                              disabled: _vm.checkKYCError(),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.decideStep(103)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-check" }),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("creation_forms.vldt")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.showActionButtonValidateBackOffice()
                ? [
                    _c(
                      "b-col",
                      {
                        staticClass: "form-group",
                        attrs: { md: "3", "offset-md": "6" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.refuseStep()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-timer" }),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("common.refus")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { md: "3" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.decideStep(104)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-check" }),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("creation_forms.vldt")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }